import Button from '@shared/components/core/button/CoreButton';
import ContentDialog from '@shared/components/core/dialog/ContentDialog';
import { useAlertsStore } from '@shared/hooks/state/AlertsContainer';
import { useOrganizationStore } from '@shared/hooks/state/OrganizationContainer';
import OrganizationAuthClientModel from '@shared/models/organizations/OrganizationAuthClientModel';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ClientSecretDialog from './ClientSecretDialog';

export interface IClientRotateSecretProps {
    organizationId: string;
    clientId: string;
}

export default function ClientRotateSecret({ clientId, organizationId }: IClientRotateSecretProps) {
    const { t } = useTranslation();

    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [showSecret, setShowSecret] = useState<boolean>(false);
    const [result, setResult] = useState<OrganizationAuthClientModel | null>(null);

    const handleCancelWarning = () => {
        setShowWarning(false);
    };

    const handleRotateClientSecret = async () => {
        setShowWarning(false);
        try {
            const response = await useOrganizationStore.getState().rotateClientSecret(organizationId, clientId);
            if (response?.resultType == 'Ok') {
                setResult(response.data);
                setShowSecret(true);
            }
        } catch (error) {
            useAlertsStore.getState().showError(t('common:organization.projects.secret.rotate.error'));
        }
    };

    if (!organizationId || !clientId) return null;
    return (
        <>
            <Button $color="accent" startIcon="repeat" onClick={() => setShowWarning(true)}>
                {t('common:organization.projects.secret.rotate.title')}
            </Button>
            <ContentDialog
                open={showWarning}
                onCancel={handleCancelWarning}
                onClose={handleCancelWarning}
                onConfirm={handleRotateClientSecret}
                confirmButtonText={t('common:continue')}
                title={t('common:organization.projects.secret.rotate.title')}
                description={t('common:organization.projects.secret.rotate.description')}
            />
            <ClientSecretDialog secret={result?.secret ?? ''} open={showSecret} onClose={() => setShowSecret(false)} />
        </>
    );
}
